import axiosInstance from './axiosInstance'

export const getBackWrapPricingConfig = () => {
  return axiosInstance.get('/static-pricings-config/backwrap')
}

export const setBackWrapPricingConfig = (data) => {
  return axiosInstance.post('/static-pricings-config/backwrap', data)
}

export const getSideVentPricingConfig = () => {
  return axiosInstance.get('/static-pricings-config/sidevent')
}

export const setSideVentPricingConfig = (data) => {
  return axiosInstance.post('/static-pricings-config/sidevent', data)
}

export const getCabinetPricingConfig = () => {
  return axiosInstance.get('/static-pricings-config/cabinet')
}

export const setCabinetPricingConfig = (data) => {
  return axiosInstance.post('/static-pricings-config/cabinet', data)
}

export const getPedestalPricingConfig = () => {
  return axiosInstance.get('/static-pricings-config/pedestal')
}

export const setPedestalPricingConfig = (data) => {
  return axiosInstance.post('/static-pricings-config/pedestal', data)
}

export const getMowCurbPricingConfig = () => {
  return axiosInstance.get('/static-pricings-config/mow-curb')
}

export const setMowCurbPricingConfig = (data) => {
  return axiosInstance.post('/static-pricings-config/mow-curb', data)
}
